import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <p><strong>Description</strong></p>
  <p>This action triggers when a Stow Associate incorrectly Scans Oversized packages to Non-Oversized Sort Zone bags. Oversized packages are packages that have “Oversized” on the SLAM label.&nbsp;</p>
  <p><strong>Impact</strong></p>
  <p>
      Sort zone bags are reserved for NON-OVERSIZED packages (i.e. jiffies, A4,etc). Any package marked “OVERSIZED” on the SLAM label must be stowed to an Oversize rack. By stowing Oversized packages into sort zone bags, sites may see
      their bags get overfilled which may lead to:<br />
      • Over-utilization of bags and double binning<br />
      • Unpicked packages (1 of every 5 OV to Non OV defects fail to get picked)
  </p>
  <p>
      This action encourages an L3+ Leader to perform the <span className="wikiinternallink"><a href="https://apollo-audit.corp.amazon.com/audits/new?audit_type_id=8252">SCC Work Item - OV to Bag</a></span> Audit in Apollo with the associate
      to help direct the seek to understand conversation on why the associate is stowing oversized packages to the sort zone bags.&nbsp;
  </p>
  <p><strong>Resolution Steps</strong></p>
  <p>
      1.Locate the Stower(s) that triggered the Alert. &nbsp;<br />
      2.Conduct the <span className="wikiinternallink"><a href="https://apollo-audit.corp.amazon.com/audits/new?audit_type_id=8252">SCC Work Item - OV to Bag</a></span> Audit in Apollo<br />
      3.After completing the audit, close the action&nbsp;&nbsp;
  </p>
  <div className="wikimodel-emptyline"></div>
  <p><strong>Supplemental Links</strong></p>
  <p>
      1.
      <span className="wikiinternallink">
          <a
              href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/5571ef06-acb5-4bae-a3ed-5d19a4859a62/sheets/5571ef06-acb5-4bae-a3ed-5d19a4859a62_2275a8a3-aa88-429c-91ea-77b6a5aedb77?directory_alias=amzlbiaquicksight&amp;qs-signin-user-auth=false"
          >
              FPY Dashboard
          </a>
      </span>
      <br />
      2.<span className="wikiinternallink"><a href="https://apollo-audit.corp.amazon.com/audits/new?audit_type_id=8252">SCC Work Item - OV to Bag</a></span> Audit in Apollo<br />
      3.
      <span className="wikiinternallink">
          <a href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/e5996fbe-2141-490a-adad-d5e8819be562/sheets/e5996fbe-2141-490a-adad-d5e8819be562_012c3736-bc21-428a-a187-996fe2ea26c2">
              NA AMZL Manager (SCC &amp; GCA) Alert Qicksight Dashboard
          </a>
      </span>
      <br />
      4.
      <span className="wikiinternallink">
          <a
              href="https://start.wwops.amazon.dev/boards/browse?boardId=IjEyMzE5Ig%3D%3D&amp;businessUnitId=IjMi&amp;cardId=IjIzNzcyMyI%3D&amp;selectedTagValueIds=WyIzMDQiLCIzMTUiLCIzNzkiXQ%3D%3D&amp;topLevelFilters=eyI0IjoiNDEiLCI2IjoiNDkifQ%3D%3D#h1-237723-1"
          >
              START Tetris
          </a>
      </span>
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_OV_TO_BAG.jsx